import { Construction } from "lucide-react";
import { DashboardLayout } from "../../client/components/Sidebar";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";
import type { BuildingManagementModule } from "./modules";

export function createModulePlaceholderPage(module: BuildingManagementModule) {
  return function BuildingManagementPlaceholderPage() {
    useRequireSectionVisible(module.sectionKey);
    return (
      <DashboardLayout>
        <div className="mx-auto max-w-2xl px-4 py-16 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-50 text-amber-700">
            <Construction className="h-7 w-7" />
          </div>
          <p className="text-xs font-semibold uppercase tracking-widest text-sky-700">
            Building management module
          </p>
          <h1 className="mt-2 text-3xl font-bold">{module.label}</h1>
          <p className="mt-3 text-neutral-600">{module.description}</p>
          <p className="mt-6 text-sm text-neutral-500">
            This module is available to any portal pack via section visibility.
            Full workflow UI comes next; the Documents module is live now.
          </p>
        </div>
      </DashboardLayout>
    );
  };
}
